import { render, staticRenderFns } from "./Overline.vue?vue&type=template&id=55dbb8c0&"
import script from "./Overline.vue?vue&type=script&lang=js&"
export * from "./Overline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports